import { useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";

export default function PageTransition({ children }) {
  const location = useLocation();
  const [displayChildren, setDisplayChildren] = useState(children);
  const [phase, setPhase] = useState("idle"); // idle | out | in
  const prevPath = useRef(location.pathname);

  useEffect(() => {
    // Pas de transition sur /abonnement (Wash Bros a sa propre animation)
    if (location.pathname === prevPath.current) return;
    if (location.pathname === "/abonnement") {
      prevPath.current = location.pathname;
      setDisplayChildren(children);
      return;
    }

    prevPath.current = location.pathname;
    setPhase("out");

    const t1 = setTimeout(() => {
      setDisplayChildren(children);
      setPhase("in");
    }, 180);

    const t2 = setTimeout(() => {
      setPhase("idle");
    }, 380);

    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [location.pathname, children]);

  const style = {
    transition: "opacity 0.18s ease, transform 0.18s ease",
    opacity: phase === "out" ? 0 : 1,
    transform: phase === "out" ? "translateY(6px)" : "translateY(0)",
  };

  return <div style={style}>{displayChildren}</div>;
}
